import { apiConstants } from '../config';
let code = apiConstants.code;
let codeAPI = apiConstants.codeAPI;
const state = {
    error: null,
    loading: false,
    data: {
        code: code,
        codeAPI: codeAPI,
        module: {},
        panels: {
            home: {
                panel: {

                },
                acl: {

                },
                url: {
                    estimateBuilding: `${codeAPI}/front/estimate/building/:mode/:lat/:lng`,
                    estimate : `${codeAPI}/front/estimate`,
                },
            },
            headernav: {
                tools: [
                    {component: 'dashboard', title: 'dashboard.title'},
                ]
            },
        },
        tools: {
            attribution: {
                active: false,
            },
            scaleline: {
                active: false,
            },
            scalebox: {
                active: false,
            },
            mouseposition: {
                active: false,
            },
            geolocation: {
                active: true,
                title: 'geolocation.titles',
            },
            fullscreen: {
                active: true,
                title: 'fullscreen.toggle',
            },
            layerswitcher: {
                active: false,
            },
            streetview: {
                active: false,
            },
            expandcollapse: {
                active: false,
            },
            annotations: {
                active: false,
            },
            measure: {
                active: false,
            },
            catalog: {
                active: false,
            },
            identify: {
                active: false,
            },



            backoffice: {
                active: false,
                title: 'Backoffice',
                label: 'Backoffice',
                panel: {
                    show: false,
                },
                acl: {
                    view: 'IG_00006',
                },
                url: {
                    view: `:moduleCodegestao.home`,
                }
            },
            layers: {
                active: false,
                title: 'Camadas',
                label: 'Camadas',
                panel: {
                    show: false,
                    loaded: false,
                },
                acl: {
                    view: 'IG_00002',
                },
                url: {
                    getLayers: `${codeAPI}/front/map/layers`,
                },
            },
            dashboard: {
                active: true,
                panel: {
                    show: false,
                    loaded: false,
                },
                acl: {
                    view: 'IG_00007',
                },
            },
            navsearch: {
                active: true,
                panel: {
                    show: true,
                    showDefault: true,
                    categories: [{
                        'id': 'addr',
                        'name': 'navsearch.address.title',
                        'url': '../gateway/address/search',
                        'listGroup': 'adminName1',
                        'labelTemplate': 'navsearch.address.labelTemplate',
                        'subLabelTemplate': null,
                        'placeholder': 'navsearch.address.placeholder'
                    }],
                    search: {
                        category: null,
                        item: null,
                        search: null,
                    },
                },
                acl: {
                    view: null,
                },
            },
            estimate: {
                active: true,
                panel: {
                    show: false,
                    loaded: false,
                    feature: null,
                    addressPosition: {
                        id: null,
                        geojson: null,
                        avg_ps: null,
                        threshold_area: null,
                        area: null,
                    },
                    estimateResults: undefined,
                },
                acl: {
                    view: null,
                    detail : 'IG_00007',
                },
                url: {
                    // estimateBuilding: `${codeAPI}/front/estimate/building/:lat/:lng`,
                },
            },
        },
        map: {
            loading: false,
            action: null,
            config: {
                layers: {
                    estimate: {
                        layer: 'lyr_estimate',
                        source: 'vs_estimate',
                        zindex: 999,
                        duration: 1500,
                        zoomScale: 4,
                        timeout: 10000,
                    },
                },
                interactions: {
                    draw: {
                    },
                },
            }
        },
        config: {

        },
    },
};

export default state;